import script from "./SolutionView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SolutionView.vue?vue&type=script&lang=ts&setup=true"

import "./SolutionView.vue?vue&type=style&index=0&id=29362183&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29362183"]])

export default __exports__